import { render, staticRenderFns } from "./EmailBuilderBulkPanel.vue?vue&type=template&id=454996f7&scoped=true"
import script from "./EmailBuilderBulkPanel.vue?vue&type=script&lang=ts"
export * from "./EmailBuilderBulkPanel.vue?vue&type=script&lang=ts"
import style0 from "./EmailBuilderBulkPanel.vue?vue&type=style&index=0&id=454996f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454996f7",
  null
  
)

export default component.exports